export default "__VITE_ASSET__DSLg6$gh__"